import React from "react";
import Header from "../components/common/Header";
import AdventurePath from "../components/AdventurePath";

const AdventurePathPage = () => {
  return (
    <div className="page-container">
      <div className="content-card">
        <AdventurePath />
      </div>
    </div>
  );
};

export default AdventurePathPage;
